import React from "react"
import PropTypes from "prop-types"

const SchemaSnippet = props => {
    const { snippet } = props
    return <script type={"application/ld+json"} dangerouslySetInnerHTML={{ __html: snippet }} />
}

SchemaSnippet.propTypes = {
    snippet: PropTypes.string,
}

export default SchemaSnippet
